export const viewGoogleMapLocation=(originLatitude:number,originLongitude:number,destinationLatitude:number,destinationLongitude:number)=>{
    window.open(`https://www.google.com/maps/dir/?api=1&origin=${originLatitude},${originLongitude}&destination=${destinationLatitude},${destinationLongitude}`);
}